module.exports = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};


//# sourceMappingURL=zh-CN.main.js.map
